import {
	toParams,
	fromParamMap,
} from 'src/admin-app/utilities/list-filtering/shared';
import { CustomerListArgs } from 'src/shared/api';
import {
	toTextFilterParams,
	toTextFilterListArgs,
	toPagingParams,
	toSortingParams,
	toPagingListArgs,
	toSortingListArgs,
	toFieldTeamParams,
	toFieldTeamListArgs,
} from 'src/admin-app/utilities/list-filtering/mappers';

export const convertToCustomersParams = toParams<CustomerListArgs>(
	toTextFilterParams,
	toPagingParams,
	toSortingParams,
	toFieldTeamParams
);

export const convertToCustomersListArgs = fromParamMap<CustomerListArgs>(
	toTextFilterListArgs,
	toPagingListArgs,
	toSortingListArgs,
	toFieldTeamListArgs
);
